'use client';

import ThemeProvider from '@carvana/showroom-theme';
import theme from '~/theme';

interface ClientThemeProviderProps {
  children: React.ReactNode;
}

export default function ThemeProviderWrapper({
  children
}: ClientThemeProviderProps) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
